/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import DiabeticForm from '../forms/DiabeticForm/DiabeticForm';
import { Box, Divider, Paper, Typography } from '@mui/material';
import FootForm from '../forms/FootForm/FootForm';
import useMasterApi from '../../services/useMasterApi';
import { ENDPOINT } from '../../services/endPoints';
import CustomLoader from '../../components/CustomLoader/CustomLoader';
import DoctorCommentsForm from '../forms/DoctorCommentsForm/DoctorCommentsForm';
import PatientImages from '../forms/DiabeticForm/PatientImages';



const RecordForm = () => {
  const {getWithQueryParams, data, loading } = useMasterApi()
  const location = useLocation();
  const [isRejected, setIsRejected] = useState(false);

    const { form_code, formType } = location.state;

  useEffect(()=>{
    getWithQueryParams(`${ENDPOINT.PATIENT_RECORD}/${form_code}`, {form_type: formType} )
  },[form_code])

  useEffect(()=>{
    if(isRejected){
      getWithQueryParams(`${ENDPOINT.PATIENT_RECORD}/${form_code}`, {form_type: formType} )
    }
  },[isRejected])

   if(loading){
    return <CustomLoader/>
  }
    return (
    <>
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
    <Box sx={{ borderRadius: "12px" }} component={Paper} elevation={2}>
      {formType === "2" ? <DiabeticForm formData={data?.formValues} rejected={{isRejected, setIsRejected}}/> : <FootForm formData={data?.formValues} rejected={{isRejected, setIsRejected}}/>}
    </Box>
    <PatientImages formData={data?.formImages?.values?.rows}/>
      <DoctorCommentsForm formData={data?.formValues}/>
      <Divider/>
      {data?.formValues?.doctore_comments1 && data?.formValues?.doctore_comments1 !== "" && <Box sx={{ display:"flex", flexDirection: "column", gap: "0.5rem" }}>
      <Typography variant='h1' color="primary" sx={{fontWeight:"bold", textAlign: "center", textDecoration:"underline" }}>Rejection Reason:
       </Typography>
       <Typography variant='h2' color="error" sx={{fontWeight:"bold", textAlign: "center"}}>{data?.formValues?.doctore_comments1}
       </Typography>
       </Box>}
      </Box>
    
    </>
  )
}

export default RecordForm